module.exports = __webpack_public_path__ + "img/strategie.73da90fd.png";